import React, { useCallback, useState } from 'react';
import Box from 'fe-design-base/atoms/Box';
import FDBDatePicker from 'fe-design-base/organisms/FDBDatePicker';
import PropTypes from 'prop-types';

import EmployeeSelect from 'features/timesheets/TimesheetsPage/TimecardModal/EditMode/Header/EmployeeSelect';
import RoleSelectInput from 'features/timesheets/TimesheetsPage/TimecardModal/EditMode/Header/RoleSelectInput';

import { cxHelpers } from 'util/className';
import { formatDate } from 'util/dateTime';

const { cx } = cxHelpers('HeaderNewTimecard');

const NewTimecard = ({
  employeeJobId,
  setEmployeeJobId,
  roleId,
  setRoleId,
  timecardDate,
  setTimecardDate,
  employeeOptions,
  roleOptions,
  locationName,
  addLocationRole,
  setChangesMade,
}) => {
  const [dateValue, setDateValue] = useState(timecardDate);
  const handleDateChange = useCallback(
    e => {
      const date = e.target.value;

      setDateValue(date);
      setTimecardDate(formatDate(date, 'parsable_date'));
    },
    [setTimecardDate]
  );
  return (
    <Box className={cx()}>
      <Box row spacebetween>
        <Box>
          <Box row>
            <Box maxw={210}>
              <FDBDatePicker
                name="date"
                value={dateValue}
                onChange={handleDateChange}
                blockFutureDates
              />
            </Box>
            <Box w={220} ml={8}>
              <EmployeeSelect
                employeeJobId={employeeJobId}
                employees={employeeOptions}
                setEmployeeJobId={setEmployeeJobId}
              />
            </Box>
          </Box>
          <Box mt={5}>
            <RoleSelectInput
              roleId={roleId}
              roleOptions={roleOptions}
              addLocationRole={addLocationRole}
              setRoleId={setRoleId}
              locationName={locationName}
              setChangesMade={setChangesMade}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

NewTimecard.propTypes = {
  roleName: PropTypes.string,
  locationName: PropTypes.string,
  editMode: PropTypes.bool,
  newTimecard: PropTypes.bool,
  setChangesMade: PropTypes.func.isRequired,
};

export default NewTimecard;
